import { type MemoExoticComponent, memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { ASSIGNMENT_TAGS } from '@didaskill/domain/assignments/constants';
import { type TAG_HUES, Tag } from '@didaskill/ui/design-system';
import { assignmentTagsMessages } from '@didaskill/ui/intl';

const ASSIGNMENT_TAG_COLOR_MAPPING: Record<ASSIGNMENT_TAGS, TAG_HUES> = {
  [ASSIGNMENT_TAGS.CONTINUOUS_ASSESSMENT]: Tag.HUES.RED,
  [ASSIGNMENT_TAGS.PROFESSIONAL_FILE]: Tag.HUES.PURPLE,
};

export type AssignmentTagProps = {
  assignmentTag: ASSIGNMENT_TAGS;
};

export const AssignmentTagBase = ({ assignmentTag }: AssignmentTagProps) => (
  <Tag
    hue={ASSIGNMENT_TAG_COLOR_MAPPING[assignmentTag]}
    label={<FormattedMessage {...assignmentTagsMessages[assignmentTag]} />}
    light
  />
);

AssignmentTagBase.displayName = 'AssignmentTag';

export const AssignmentTag: MemoExoticComponent<typeof AssignmentTagBase> & {
  TAG_COLOR_MAPPING?: typeof ASSIGNMENT_TAG_COLOR_MAPPING;
} = memo(AssignmentTagBase);

AssignmentTag.TAG_COLOR_MAPPING = ASSIGNMENT_TAG_COLOR_MAPPING;
